import Vue from 'vue'
import eventBus from '@/plugins/eventbus'
import $store from "@/plugins/store"

import {
  EVENT_EXT_NATIVE_APP_READY,
  EVENT_EXT_NATIVE_APP_NOTIFICATION_INFO,
  EVENT_EXT_NATIVE_APP_PUSH_NOTIFICATION_INFO,
  EVENT_LOGIN_AFTER,
} from '@/plugins/eventbus'

window.espocial = (window.espocial ? window.espocial : {})
window.espocial.eventBus = eventBus

window.espocial.updateDeviceToken = function(devType, token) {
  console.log('updateDeviceToken called', devType, token)
};

// functions for the native app

window.espocial.nativeAppReady = function(type) {
  eventBus.$emit(EVENT_EXT_NATIVE_APP_READY, {type: type})
  window.espocial.nativeLog("INFO: User isLoggedIn: " + ($store.state.isLoggedIn ? 'yes' : 'no'));
  if ($store.state.isLoggedIn) {
    window.espocial.nativeRequestPushToken()
  }
}

window.espocial.nativeAppNotificationsInfo = function(data) {
  if (typeof data != "object") {
    window.espocial.nativeLog("ERROR: The native app provided a non object on nativeAppNotificationsInfo");
  }
  eventBus.$emit(EVENT_EXT_NATIVE_APP_NOTIFICATION_INFO, data)
}

window.espocial.nativeAppPushNotificationsInfo = function(data) {
  if (typeof data != "object") {
    window.espocial.nativeLog("ERROR: The native app provided a non object on nativeAppPushNotificationsInfo");
  }
  eventBus.$emit(EVENT_EXT_NATIVE_APP_PUSH_NOTIFICATION_INFO, data)
}

// functions for the PWA internally

window.espocial.nativeRequestPushToken = function() {
  if (window.espocial.native && window.espocial.native.requestPushToken) {
    window.espocial.native.requestPushToken()
  } else {
    console.log('WARN: espocial.native.requestPushToken function is not available')
  }
}

window.espocial.nativeAlert = function(message, title) {
  if (window.espocial.native && window.espocial.native.alert) {
    window.espocial.native.alert(message, title)
  } else {
    console.log('WARN: espocial.native.alert function is not available')
  }
}

window.espocial.nativeLog = function(message) {
  if (window.espocial.native && window.espocial.native.log) {
    window.espocial.native.log(message)
  } else {
    console.log('WARN: espocial.native.log function is not available')
  }
}

eventBus.$on(EVENT_LOGIN_AFTER, () => {
  window.espocial.nativeRequestPushToken()  
});

let nativeApp = {
  isActive: function () {
    return $store.state.nativeApp.ready
  },
  isIOS: function () {
    return this.isActive() && $store.state.nativeApp.type == 'ios'
  }
}

Vue.prototype.$nativeApp = nativeApp

export default window.espocial
